require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-being-more-financially-savvy-is-just-five-minutes-away.json") })
        }
      }, "path---es-articles-being-more-financially-savvy-is-just-five-minutes-away");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-being-more-financially-savvy-is-just-five-minutes-away!./.cache/json/es-articles-being-more-financially-savvy-is-just-five-minutes-away.json
// module id = 2068
// module chunks = 231608221292675